/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Sesso } from './sesso';


/**
 * PUT request body per /profilo (cittadino, gestione, servizi).
 */
export interface UserProfileUpdateForm { 
    /**
     * Optimistic lock version. Obbligatorio per update di profilo esistente (409 su mismatch). Nullable per auto-create operatore (D8 revisionato).
     */
    version?: number;
    /**
     * Codice fiscale. Campo system-only: se non-null produce 422.
     */
    codice_fiscale?: string;
    sesso?: Sesso;
    data_nascita?: string;
    comune_nascita?: string;
    provincia_nascita?: string;
    nazione_nascita?: string;
    indirizzo_residenza?: string;
    comune_residenza?: string;
    provincia_residenza?: string;
    cap_residenza?: string;
    cellulare?: string;
    telefono_fisso?: string;
    email?: string;
}



